import styled from 'styled-components';
import { Input } from 'antd';

export const SearchGroup = styled.div`
    flex: 1;
    min-width: 240px;
    display: flex;
`;

export const SearchInput = styled(Input)`
    flex: 1;
    height: 42px;
    border-radius: 8px 0 0 8px;
`;

export const ScanButton = styled.button`
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    border: none;
    border-radius: 0 8px 8px 0;
    background: ${({ theme }) => theme.colors.accentColor};
    color: ${({ theme }) => theme.colors.colorTextLightSolid};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
